import React, { useState } from "react";
import SoftwareList from "./components/SoftwareList";
import FileUpload from "./components/FileUpload";

function App() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [showAdmin, setShowAdmin] = useState(false);

  const handleChange = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="min-vh-100">
      <header className="rs-header">
        <div className="container rs-header__inner">
          <div className="rs-header__brand">
            <img
              src="/riosat-logo.jpg"
              alt="RioSat Logo"
              className="rs-header__logo"
            />
            <div>
              <h1 className="rs-header__title">RioSat Yazılımları</h1>
              <p className="rs-header__subtitle">Resmi indirme merkezi</p>
            </div>
          </div>
          <button
            type="button"
            className={`rs-btn-admin${showAdmin ? " rs-btn-admin--active" : ""}`}
            onClick={() => setShowAdmin((prev) => !prev)}
          >
            {showAdmin ? "✕ Yönetimi Kapat" : "⚙ Yönetim Paneli"}
          </button>
        </div>
      </header>

      <main className="container pb-5">
        {!showAdmin && (
          <section className="rs-hero">
            <h2 className="rs-hero__title">Ürün Yazılımlarını İndirin</h2>
            <p className="rs-hero__text">
              RioSat cihazlarınız için güncel firmware ve yazılımlara güvenle
              erişin.
            </p>
          </section>
        )}

        {showAdmin && <FileUpload onUploadSuccess={handleChange} />}

        <SoftwareList
          refreshKey={refreshKey}
          showAdmin={showAdmin}
          onDelete={handleChange}
        />
      </main>
    </div>
  );
}

export default App;
